export enum LegalForm {
    OOO = "OOO",
    OAO = "OAO",
    PAO = "ПAO",
}
